import styled from 'styled-components/macro';
import { ResultsBox } from 'components/tools/SearchPage/Search.styles';

const ResultsHeaderColumn = styled.div`
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
`;

const ResultsHeaderRow = styled.div`
  padding: 8px 0px 8px 58px;
  line-height: 1.42857143;
  vertical-align: top;
  color: #707b90 !important;
  display: flex;
`;

const Results = styled(ResultsBox)`
  padding: 30px;
`;

export { ResultsHeaderColumn, ResultsHeaderRow, Results };
